// Official brand logos (Wikimedia + brand sites + web.archive.org heritage logos); wordmark fallbacks elsewhere
export const LOGOS = {
  "google": "/logos/google.svg",
  "amazon": "/logos/amazon.svg",
  "mands": "/logos/mands.svg",
  "nhs": "/logos/nhs.svg",
  "pepsico": "/logos/pepsico.svg",
  "kelloggs": "/logos/kelloggs.svg",
  "aryzta": "/logos/aryzta.svg",
  "crown": "/logos/crown.svg",
  "imtech": "/logos/imtech.svg",
  "northvolt": "/logos/northvolt.svg",
  "pacgroup": "/logos/pacgroup.png",
  "muller": "/logos/muller.svg",
  "pmgroup": "/logos/pmgroup.png",
  "bovishomes": "/logos/bovishomes.png"
};
